<app-navbar [navList]="navList" entityName="Utente" [search]="true" createButton="show" i18n-searchPlaceholder
    searchPlaceholder="Cerca per Nome, Cognome, Email..." (searchEvent)="searchValue = $event"></app-navbar>
<div class="qai-content-box overflow-auto">
    <app-shared-table [tableHead]="filteredUsers.length > 7 ? 'solid' : 'trasparent'" [columns]="userColumns" [items]="filteredUsers" [isLoading]="loading"
        [multiActions]="[{ label: 'Elimina', action:'delete', buttonType: 'danger' }]"
        (multiActionEvent)="$event.action === 'delete' && deleteUsers($event.list);" [searchTerm]="searchValue"
        (openDetailEvent)="openUserDetail($event)" [tableHeightElems]="7" (navigateSubListElem)="navigateDetail($event)">
    </app-shared-table>
</div>